<div class="col-12" *ngIf="isVisible">
  <button
    class="d-flex justify-content-center align-items-center w-100 z-1"
    [style]="bg"
    [disabled]="isLoading"
    style="border-radius: 40px; border: none; padding: 4px 16px; position: relative;"
    (click)="addToWallet()"
  >
    <img
      *ngIf="actionImg.includes('apple') && !isLoading"
      [src]="actionImg"
      class="img-fluid cl"
      style="height: 26px; width: 26px; padding: 3px 0px;"
      alt="Add to Apple Wallet"
    />

    <img
      *ngIf="actionImg.includes('google') && !isLoading"
      [src]="actionImg"
      class="img-fluid rounded-start rounded-tix cl"
      style="height: 30px"
      alt="Add to Google Wallet"
    />

    <ng-container *ngIf="isLoading">
      <span
        class="spinner-border spinner-border-sm ml-2"
        role="status"
        aria-hidden="true"
        style="width: 1.5rem; height: 1.5rem; color: #fff;"
      ></span>
      <span style="color:#fff;" class="visually-hidden">Loading...</span>
    </ng-container>

    <ng-container *ngIf="actionImg.includes('apple') && !isLoading">
      <span style="color:#fff; white-space: nowrap; font-size: 0.875rem; font-weight: 500; margin-left: 10px;">Agregar a Apple Wallet</span>
    </ng-container>
  </button>
</div>